import React from 'react';
import { ExclamationCircleFill } from 'react-bootstrap-icons';

interface CustomWarningProps {
  children: React.ReactNode;
}

export const CustomWarning: React.FC<CustomWarningProps> = ({ children }) => {
  return (
    <div style={{ padding: '1rem', background: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '0.25rem', color: '#856404' }}>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
        <div>
          <ExclamationCircleFill size={25}/>
        </div>
        {children}
      </div>
    </div>
  );
};
